import { BUTTON, IMAGE, PAGE, RECTANGLE, TEXT, VIDEO, SHAPE, LINE, SECTION, SECTION_COLUMN, CONTAINER, FORM, FORM_STEP, FORM_FIELD, FORM_SUBMIT, FORM_NUMBER, FORM_TEXTAREA, FORM_CHECK_BOX, FORM_DROPDOWN_LIST, SEEK, FORM_CHECK_LIST, GROUP, HTML, IFRAME, LIVE_ELEMENT, LIVE_ELEMENT_CONTAINER, MENU_CONTAINER, MENU, MENU_DRAGGABLE_CONTAINER, CONTENT, CONTENT_CARD, BASIC_TEXT, CONTENT_PAGINATION_BUTTON, ASSET, CAROUSEL, CAROUSEL_CARD, OTP_INPUT, OTP_FORM_SUBMIT, OTP_RESEND, EXTERNAL_FORM } from "constants/widgetTypes";
import { renderPageWidget } from "./rendererWidgets/page";
import { renderRectangleWidget } from "./rendererWidgets/rectangle";
import { renderButtonWidget } from "./rendererWidgets/button";
import { renderTextWidget } from "./rendererWidgets/text";
import { renderImageWidget } from "./rendererWidgets/image";
import { renderVideoWidget } from "./rendererWidgets/video";
import { renderShapeWidget } from "./rendererWidgets/shape";
import { renderLineWidget } from "./rendererWidgets/line";
import { renderSectionWidget } from "./rendererWidgets/section/section";
import { renderSectionColumnWidget } from "./rendererWidgets/section/column";
import { renderContainerWidget } from "./rendererWidgets/container";
import { renderFormWidget } from "./rendererWidgets/form/form";
import { renderFormStepWidget } from "./rendererWidgets/form/formStep";
import { renderFormFieldWidget } from "./rendererWidgets/form/formField";
import { renderFormSubmitWidget } from "./rendererWidgets/form/formSubmit";
import { renderNumberFieldWidget } from "./rendererWidgets/form/numberField";
import { renderTextareaFieldWidget } from "./rendererWidgets/form/textArea";
import { renderBooleanFieldWidget } from "./rendererWidgets/form/checkBox";
import { renderDropdownFieldWidget } from "./rendererWidgets/form/dropdownList";
import { renderSeekWidget } from "./rendererWidgets/seek";
import { renderCheckboxFieldWidget } from "./rendererWidgets/form/checkBoxList";
import { renderOtpInputtWidget } from "./rendererWidgets/form/otpInput";
import { renderGroupWidget } from "./rendererWidgets/group";
import { renderHtmlWidget } from "./rendererWidgets/html";
import { renderIFrameWidget } from "./rendererWidgets/iframe";
import { renderLiveElementWidget } from "./rendererWidgets/liveElement/liveElement";
import { renderLiveElementContainerWidget } from "./rendererWidgets/liveElement/liveElementContainer";
import { renderMenuWidget } from "./rendererWidgets/menu/menu";
import { renderMenuContainerWidget } from "./rendererWidgets/menu/menuContainer";
import { renderMenuDraggableContainerWidget } from "./rendererWidgets/menu/menuDraggableContainer";
import { renderContentWidget } from "./rendererWidgets/content/content";
import { renderContentCardWidget } from "./rendererWidgets/content/contentCard";
import { renderBasicTextWidget } from "./rendererWidgets/basicText";
import { renderAssetWidget } from "./rendererWidgets/asset";
import { renderCarouselWidget } from "./rendererWidgets/carousel/carousel";
import { renderCarouselCardWidget } from "./rendererWidgets/carousel/carouselCard";
import { renderExternalFormWidget } from "./rendererWidgets/externalForm";
import { renderFonts } from "./rendererWidgets/commonStyles";
import html2canvas from "html2canvas";

const renderers = {
    [PAGE] : renderPageWidget,
    [RECTANGLE] : renderRectangleWidget,
    [TEXT]: renderTextWidget,
    [BASIC_TEXT]: renderBasicTextWidget,
    [BUTTON]: renderButtonWidget,
    [IMAGE]: renderImageWidget,
    [VIDEO]: renderVideoWidget,
    [SHAPE]: renderShapeWidget,
    [LINE]: renderLineWidget,
    [SECTION]: renderSectionWidget,
    [SECTION_COLUMN]: renderSectionColumnWidget,
    [CONTAINER]: renderContainerWidget,
    [FORM]: renderFormWidget,
    [FORM_STEP]: renderFormStepWidget,
    [FORM_FIELD]: renderFormFieldWidget,
    [FORM_SUBMIT]: renderFormSubmitWidget,
    [FORM_NUMBER]: renderNumberFieldWidget,
    [FORM_TEXTAREA]: renderTextareaFieldWidget,
    [FORM_CHECK_BOX]: renderBooleanFieldWidget,
    [FORM_CHECK_LIST]: renderCheckboxFieldWidget,
    [FORM_DROPDOWN_LIST]: renderDropdownFieldWidget,
    [OTP_INPUT]: renderOtpInputtWidget,
    [OTP_FORM_SUBMIT]: renderButtonWidget,
    [OTP_RESEND]: renderButtonWidget,
    [SEEK]: renderSeekWidget,
    [GROUP]: renderGroupWidget,
    [HTML]: renderHtmlWidget,
    [IFRAME]: renderIFrameWidget,
    [LIVE_ELEMENT]: renderLiveElementWidget,
    [LIVE_ELEMENT_CONTAINER]: renderLiveElementContainerWidget,
    [MENU]: renderMenuWidget,
    [MENU_CONTAINER]: renderMenuContainerWidget,
    [MENU_DRAGGABLE_CONTAINER]: renderMenuDraggableContainerWidget,
    [CONTENT]: renderContentWidget,
    [CONTENT_CARD]: renderContentCardWidget,
    [CONTENT_PAGINATION_BUTTON]: renderButtonWidget,
    [ASSET]: renderAssetWidget,
    [CAROUSEL]: renderCarouselWidget,
    [CAROUSEL_CARD]: renderCarouselCardWidget,
    [EXTERNAL_FORM]: renderExternalFormWidget

};

export async function generateHTML(widgets, pageWidget, currentBreakpoint, storyboard, availableFonts) {
    const context = {};
    const html = await fetch("/template.html").then(r => r.text());
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    context.document = doc;
    context.renderers = renderers;
    context.widgets = widgets;
    context.currentBreakpoint = currentBreakpoint;
    context.storyboard = storyboard;
    const fontIds = [
        ...new Set(
            widgets
                .filter(widget => Array.isArray(widget?.fonts))
                .flatMap(widget => widget.fonts)
        )
    ];
    
    if (fontIds.length > 0) {
        renderFonts(doc, fontIds, availableFonts);
    }

    const parentElement = doc.querySelector("#html_renderer");
    if (!parentElement) {
        throw new Error("Could not find #viewer_renderer in template.html");
    }

    const renderer = renderers[pageWidget.type];
    if (!renderer) throw new Error("No renderer for widget type: " + pageWidget.type);
    
    await renderer(context, pageWidget, parentElement);

    return doc.documentElement.outerHTML;
}

export async function generateImageSnapshotFromHTML(htmlString, breakpoint) {

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.left = "-99999px";
    iframe.style.top = "0";
    iframe.style.border = "0";
    iframe.style.visibility = "hidden";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument;

    iframeDoc.open();
    iframeDoc.write(htmlString);
    iframeDoc.close();

    await new Promise(resolve => {
        iframe.onload = resolve;
    });

    const doc = iframe.contentDocument;

    const svgImages = doc.querySelectorAll('img[src^="data:image/svg+xml"]');
    svgImages.forEach(img => {
        try {
            const base64 = img.src.split(",")[1];
            const svgText = atob(base64);

            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
            const svgElement = svgDoc.documentElement;

            svgElement.style.width = img.style.width || img.width + "px";
            svgElement.style.height = img.style.height || img.height + "px";
            svgElement.style.display = "block";

            img.replaceWith(svgElement);
        } catch (e) {
            console.warn("Failed to inline SVG image:", e);
        }
    });

    if (doc.fonts && doc.fonts.ready) {
        await doc.fonts.ready;
    }

    await new Promise(r => setTimeout(r, 100));

    const images = doc.querySelectorAll("img");
    await Promise.all(
        Array.from(images).map(img => {
            if (img.complete) return Promise.resolve();
            return new Promise(resolve => {
                img.onload = img.onerror = resolve;
            });
        })
    );

    const target = doc.getElementById("html_renderer");
    if (!target) {
        document.body.removeChild(iframe);
        throw new Error("Could not find #html_renderer in iframe");
    }

    const width = target.scrollWidth;
    const height = target.scrollHeight;

    const canvas = await html2canvas(target, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#fff",
        width: width,
        height: height,
        windowWidth: width,
        windowHeight: height,
        letterRendering: true
    });

    document.body.removeChild(iframe);

    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (!blob) {
                reject(new Error("Failed to create blob"));
                return;
            }
            const url = URL.createObjectURL(blob); 

            resolve(
                new File(
                    [blob],
                    `${breakpoint}-snapshot.jpg`,
                    { type: "image/jpeg" }
                )
            );
        }, "image/jpeg", 0.85);
    });
}


export async function generateImageSnapshot(widget, breakpoint) {
    try {
        let widgetElement = null;

        if (breakpoint === "desktop") {
            widgetElement = document.querySelector(`.editor_device_preview #${widget.uid}`);
        } else {
            widgetElement = document.getElementById(`${widget.uid}`);
        }

        if (!widgetElement) {
            console.warn("Widget element not found, returning dummy snapshot");
            return createDummySnapshot(widget, breakpoint);
        }

        const previewContainer = widgetElement.closest(".editor_device_preview");

        if (breakpoint === "desktop" && previewContainer) {
            previewContainer.style.visibility = "visible";
        }

        widgetElement.getBoundingClientRect();

        await new Promise(resolve =>
            requestAnimationFrame(() =>
                requestAnimationFrame(resolve)
            )
        );

        const canvas = await html2canvas(widgetElement, {
            scale: 1,
            useCORS: true,
            backgroundColor: "#fff"
        });

        if (breakpoint === "desktop" && previewContainer) {
            previewContainer.removeAttribute("style");
        }

        return await canvasToFile(canvas, widget, breakpoint);

    } catch (error) {
        console.error("Snapshot failed, returning dummy image:", error);
        return createDummySnapshot(widget, breakpoint);
    }
}


function canvasToFile(canvas, widget, breakpoint) {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) return reject("Blob creation failed");

            resolve(
                new File(
                    [blob],
                    `${breakpoint}-${widget.uid}.jpg`,
                    { type: "image/jpeg" }
                )
            );
        }, "image/jpeg", 0.85);
    });
}


function createDummySnapshot(widget, breakpoint) {
    const canvas = document.createElement("canvas");
    canvas.width = 600;
    canvas.height = 400;

    const ctx = canvas.getContext("2d");

    // Background
    ctx.fillStyle = "#f3f4f6";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Text
    ctx.fillStyle = "#9ca3af";
    ctx.font = "20px Arial";
    ctx.textAlign = "center";

    ctx.fillText("Snapshot Unavailable", canvas.width / 2, canvas.height / 2 - 10);
    ctx.fillText(`${widget.uid}`, canvas.width / 2, canvas.height / 2 + 25);

    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            resolve(
                new File(
                    [blob],
                    `${breakpoint}-${widget.uid}-dummy.jpg`,
                    { type: "image/jpeg" }
                )
            );
        }, "image/jpeg", 0.85);
    });
}
